module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('Toolbar', {
    attrs: {
      "currentView": _vm.currentView,
      "jsonData": _vm.jsonData,
      "productInfo": _vm.productInfo,
      "isDocomo": _vm.isDocomo,
      "isAu": _vm.isAu
    },
    on: {
      "transitionHome": function($event) {
        _vm.clickToolbarLogo = true
      },
      "showLessonScore": function($event) {
        _vm.showLessonScore = true
      },
      "showSetting": function($event) {
        _vm.showSetting = true
      },
      "audioPause": _vm.doAudioPause
    }
  }), _vm._v(" "), _c(_vm.currentView, {
    tag: "component",
    attrs: {
      "jsonData": _vm.jsonData,
      "productInfo": _vm.productInfo,
      "clickToolbarLogo": _vm.clickToolbarLogo,
      "showLessonScore": _vm.showLessonScore,
      "showSetting": _vm.showSetting,
      "showMicrophoneSelect": _vm.showMicrophoneSelect,
      "isDocomo": _vm.isDocomo,
      "showProgressHandOver": _vm.showProgressHandOver
    },
    on: {
      "startLesson": _vm.startLesson,
      "endLesson": _vm.endLesson,
      "showError": _vm.showError,
      "audioPause": _vm.doAudioPause,
      "showMicrophoneSelect": _vm.goMicrophoneSelect,
      "showProgressHandOver": _vm.goProgressHandOver,
      "showLessonScore": function($event) {
        _vm.showLessonScore = true
      }
    }
  }), _vm._v(" "), (_vm.showLoading) ? _c('Loading') : _vm._e(), _vm._v(" "), (_vm.showLessonScore) ? _c('LessonScore', {
    attrs: {
      "productInfo": _vm.productInfo
    },
    on: {
      "close": function($event) {
        _vm.showLessonScore = false
      },
      "showError": _vm.showError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showSetting) ? _c('Setting', {
    attrs: {
      "isDocomo": _vm.isDocomo
    },
    on: {
      "close": function($event) {
        _vm.showSetting = false
      },
      "showMicrophoneSelect": _vm.goMicrophoneSelect,
      "showMicrophoneSetting": _vm.goMicrophoneSetting,
      "showError": _vm.showError,
      "showFlashHelp": function($event) {
        _vm.showFlashHelp = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMicrophoneSelect) ? _c('MicrophoneSelect', {
    attrs: {
      "isSettingApply": _vm.isSettingApply
    },
    on: {
      "close": function($event) {
        _vm.showMicrophoneSelect = false
      },
      "showMicrophoneSetting": _vm.goMicrophoneSetting,
      "showMicrophoneHelp": function($event) {
        _vm.showMicrophoneHelp = true
      },
      "showError": _vm.showError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMicrophoneSetting) ? _c('MicrophoneSetting', {
    attrs: {
      "microphone": _vm.microphone
    },
    on: {
      "close": function($event) {
        _vm.showMicrophoneSetting = false
      },
      "showMicrophoneHelp": function($event) {
        _vm.showMicrophoneHelp = true
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showMicrophoneHelp) ? _c('MicrophoneHelp', {
    on: {
      "close": function($event) {
        _vm.showMicrophoneHelp = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showProgressHandOver) ? _c('ProgressHandOver', {
    on: {
      "clickButton": _vm.clickProgressHandOver,
      "close": function($event) {
        _vm.showProgressHandOver = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showErrDialog) ? _c('ErrorDialog', {
    attrs: {
      "message": _vm.errMessage,
      "buttonKind": _vm.errButtonKind,
      "isDocomo": _vm.isDocomo,
      "productInfo": _vm.productInfo
    },
    on: {
      "close": function($event) {
        _vm.showErrDialog = false
      },
      "retry": _vm.clickErrRetry
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showFlashHelp) ? _c('FlashHelp', {
    on: {
      "close": function($event) {
        _vm.showFlashHelp = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showNotice) ? _c('Notice', {
    on: {
      "close": _vm.closeNotice
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5321026c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/template-compiler?{"id":"data-v-5321026c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/.pnpm/vue-loader@12.2.2_babel-core@6.26.3_css-loader@0.28.11_lodash@4.17.21_underscore@1.13.7_4259f1e8ed219b259faa30ad7c9cf11c/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Root.vue
// module id = 625
// module chunks = 1